import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./tabmenu.css";

const tabs = [
  { path: "/admin/fullhousesetting", label: "1. Eye for details Settings", id: "tab2" },
  { path: "/admin/addcontent", label: "2. Add Content", id: "tab3" },
  { path: "/admin/custom-sequence", label: "3. Custom Sequence", id: "tab3b" },
  { path: "/admin/customize-spot", label: "4. Spot images & map", id: "tab-spot" },
];

const TabMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="custom-tabs-container">
      <ul className="nav nav-pills custom-tabs">
        {tabs.map((tab) => {
          const isActive = pathname === tab.path;
          return (
            <li key={tab.path} className="nav-item">
              <button
                type="button"
                className={`action-buttons outline ${isActive ? "active" : ""}`}
                id={tab.id}
                onClick={() => navigate(tab.path)}
              >
                {tab.label}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TabMenu;
